export default __webpack_public_path__ + "static/media/Team.db1c88a3.svg";